import { useEffect, useState } from 'react';
const query = '(prefers-reduced-motion: reduce)';
const readPreference = () => window.matchMedia?.(query).matches ?? false;
export default function useReducedMotion() {
  const [reduced, setReduced] = useState(readPreference);
  useEffect(() => {
    const media = window.matchMedia?.(query);
    if (!media) return undefined;
    const update = () => setReduced(media.matches);
    update();
    media.addEventListener?.('change', update);
    return () => media.removeEventListener?.('change', update);
  }, []);
  return reduced;
}
